export default __webpack_public_path__ + "static/media/main_section2.bce71e09.jpg";